import React, { useState } from "react"

import { Link } from "react-router-dom"
import { toast } from "sonner"

import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useRequestPasswordReset } from "@/hooks/useRequestPasswordReset"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const requestReset = useRequestPasswordReset()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) return

    requestReset.mutate(email.trim(), {
      onSuccess: () => setSubmitted(true),
      onError: (error) => toast.error("Couldn't send reset link", { description: error.message }),
    })
  }

  return (
    <div className="min-h-screen bg-palette-jungleGreen000 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          alt="DriverHive"
          className="mx-auto h-12"
          src="/images/b324345a-d7f5-4435-8a45-ce025baae0be.png"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-palette-jungleGreen900">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-palette-jungleGreen600">
          {submitted
            ? "Check your inbox"
            : "Enter your email and we'll send you a link to reset your password"}
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {submitted ? (
            // Deliberately the same whether or not the address has an account.
            <p className="text-sm text-palette-jungleGreen700">
              If an account exists for <span className="font-medium">{email.trim()}</span>, you'll
              receive an email with a link to reset your password. The link expires after an hour.
            </p>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-palette-jungleGreen700"
                >
                  Email
                </label>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Icon name="envelope" className="h-5 w-5 text-palette-jungleGreen400" />
                  </div>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                    className="pl-10"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <Button type="submit" className="w-full" disabled={requestReset.isPending}>
                {requestReset.isPending ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-sm font-medium text-palette-jungleGreen700 hover:underline"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
